import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { awsExports } from './aws-exports';

Amplify.configure(awsExports as any);

// En modo embed (modal de WordPress), Amplify usa almacenamiento en memoria
// en lugar de localStorage. Esto:
//   1. Elimina la necesidad de `allow-same-origin` en el sandbox del iframe
//      (evita el warning "iframe can escape its sandboxing").
//   2. Impide que la sesión se auto-detecte en carga fresca del iframe
//      (resuelve el "modal se cierra inmediatamente" después de logout).
//   3. Los tokens se siguen compartiendo con WordPress via postMessage.
const isEmbed = new URLSearchParams(window.location.search).get('embed') !== null;

if (isEmbed) {
  const _mem: Record<string, string> = {};
  cognitoUserPoolsTokenProvider.setKeyValueStorage({
    setItem:    async (k: string, v: string) => { _mem[k] = v; },
    getItem:    async (k: string)            => _mem[k] ?? null,
    removeItem: async (k: string)            => { delete _mem[k]; },
    clear:      async ()                     => { for (const k in _mem) delete _mem[k]; },
  });
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
